/**
 * Regar Switzerland Official Theme Scripts
 * - Flawless Multilingual Engine (EN, DE, FR) for Desktop & Mobile
 * - Seamless Shopify Route Redirection (/de, /fr, /)
 * - Complete Frontend Translation (Buttons, Headers, Modals, Countdowns, Cart)
 * - Ticket Checker Modal & Live Verification Logic
 */

document.addEventListener('DOMContentLoaded', () => {
  // -------------------------------------------------------------
  // 1. MULTILINGUAL DICTIONARY & SVG FLAGS
  // -------------------------------------------------------------
  const FLAGS_DESKTOP = {
    en: `<svg width="18" height="12" viewBox="0 0 60 30" aria-hidden="true" class="block w-full h-full"><clipPath id="act_flag_uk_s"><path d="M0,0 v30 h60 v-30 z"/></clipPath><clipPath id="act_flag_uk_t"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"/></clipPath><g clip-path="url(#act_flag_uk_s)"><path d="M0,0 v30 h60 v-30 z" fill="#012169"/><path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" stroke-width="6"/><path d="M0,0 L60,30 M60,0 L0,30" clip-path="url(#act_flag_uk_t)" stroke="#C8102E" stroke-width="4"/><path d="M30,0 v30 M0,15 h60" stroke="#fff" stroke-width="10"/><path d="M30,0 v30 M0,15 h60" stroke="#C8102E" stroke-width="6"/></g></svg>`,
    de: `<svg width="18" height="12" viewBox="0 0 18 12" aria-hidden="true" class="block w-full h-full"><rect width="18" height="4" fill="#000000"/><rect y="4" width="18" height="4" fill="#DD0000"/><rect y="8" width="18" height="4" fill="#FFCE00"/></svg>`,
    fr: `<svg width="18" height="12" viewBox="0 0 18 12" aria-hidden="true" class="block w-full h-full"><rect width="6" height="12" fill="#0055A4"/><rect x="6" width="6" height="12" fill="#FFFFFF"/><rect x="12" width="6" height="12" fill="#EF4135"/></svg>`
  };

  const FLAGS_MOBILE = {
    en: `<svg width="16" height="10" viewBox="0 0 60 30" aria-hidden="true" class="block w-full h-full"><clipPath id="mob_act_uk_s"><path d="M0,0 v30 h60 v-30 z"/></clipPath><clipPath id="mob_act_uk_t"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"/></clipPath><g clip-path="url(#mob_act_uk_s)"><path d="M0,0 v30 h60 v-30 z" fill="#012169"/><path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" stroke-width="6"/><path d="M0,0 L60,30 M60,0 L0,30" clip-path="url(#mob_act_uk_t)" stroke="#C8102E" stroke-width="4"/><path d="M30,0 v30 M0,15 h60" stroke="#fff" stroke-width="10"/><path d="M30,0 v30 M0,15 h60" stroke="#C8102E" stroke-width="6"/></g></svg>`,
    de: `<svg width="16" height="10" viewBox="0 0 18 12" aria-hidden="true" class="block w-full h-full"><rect width="18" height="4" fill="#000000"/><rect y="4" width="18" height="4" fill="#DD0000"/><rect y="8" width="18" height="4" fill="#FFCE00"/></svg>`,
    fr: `<svg width="16" height="10" viewBox="0 0 18 12" aria-hidden="true" class="block w-full h-full"><rect width="6" height="12" fill="#0055A4"/><rect x="6" width="6" height="12" fill="#FFFFFF"/><rect x="12" width="6" height="12" fill="#EF4135"/></svg>`
  };

  const translations = {
    en: {
      label: 'EN',
      // Nav
      nav_products: 'Products',
      nav_raffles: 'Raffles',
      nav_winners: 'Winners',
      nav_faq: 'FAQ',
      nav_contact: 'Contact',
      check_tickets: '🎟️ Check Tickets',
      mob_tickets: '🎟️ Tickets',
      nav_home: 'Home',
      nav_shop: 'Shop',
      nav_tickets: 'Tickets',
      nav_account: 'Account',
      nav_login: 'Login',
      // Hero
      hero_title_1: 'BUY A WHITERAX',
      hero_title_2: 'WIN A ROLEX',
      hero_sub: 'Buy 1 pack of Whiterax teeth-whitening patches for CHF 29.90 → receive 1 entry into the monthly prize draw → get the chance to win the Rolex.',
      buy_now: 'BUY NOW',
      buy_and_enter: 'BUY & ENTER',
      buy_and_enter_draw: 'BUY & ENTER DRAW',
      enter_rolex_draw: 'ENTER ROLEX DRAW • CHF 29.90',
      enter_draw_short: 'Enter Rolex Draw',
      enter_current_draw: 'ENTER CURRENT DRAW',
      add_to_cart: 'ADD TO CART',
      checkout: 'PROCEED TO CHECKOUT →',
      continue_shopping: '← Continue Shopping',
      update_cart: 'Update Cart',
      cart_eyebrow: 'YOUR ORDER & ROLEX DRAW ENTRIES',
      cart_title: 'Shopping Cart',
      cart_empty_title: 'Your cart is empty',
      cart_empty_desc: 'You do not have any items in your cart. Purchase Whiterax teeth whitening strips to receive your official ticket into the monthly Rolex draw!',
      cart_shop_btn: 'Shop Strips & Enter Raffle →',
      cart_remove: 'Remove',
      cart_clear_all: 'Clear Cart',
      cart_rolex_draw: 'Official Rolex Draw',
      cart_verified_entries: 'Verified Ticket Entries:',
      cart_draw_date_label: 'Official Draw Date:',
      cart_supervision_label: 'Supervision:',
      cart_supervision_val: 'Swiss Federal Notary',
      cart_order_summary: 'Order Summary',
      cart_discount_label: 'Discount & Voucher Code',
      cart_apply: 'Apply',
      cart_subtotal: 'Subtotal',
      cart_shipping_label: 'Swiss Express Shipping',
      cart_voucher_discount: 'Voucher Discount',
      cart_rolex_entry: 'Rolex Draw Entry',
      cart_total: 'Total',
      cart_secure_checkout: '100% Secure Checkout',
      cart_verified_draw: 'Verified Draw Entry',
      subscribe: 'SUBSCRIBE',
      view_all: 'VIEW ALL',
      verify: 'Verify',
      close: 'Close',
      // Countdown
      countdown_ends: 'ROLEX DRAW ENDS IN',
      days: 'Days',
      hours: 'Hours',
      min: 'Min',
      sec: 'Sec',
      // How it works
      how_it_works: 'HOW IT WORKS',
      how_it_works_eyebrow: 'HOW IT WORKS',
      how_it_works_heading: 'Simple steps to win',
      step1_title: 'Purchase',
      step1_desc: 'Choose your Whiterax product and complete your order.',
      step2_title: 'Get Entries',
      step2_desc: 'Every paid order automatically adds your entries to the monthly raffle.',
      step3_title: 'Win Big',
      step3_desc: 'Wait for the official draw and get the chance to win the Rolex.',
      // Shop
      shop_eyebrow: 'SHOP WHITERAX TEETH WHITENING STRIPS',
      shop_heading: 'Choose Your Whitening Strips',
      prizes_eyebrow: 'AMAZING PRIZES',
      prizes_heading: 'Win Life-Changing Prizes',
      past_winners: 'Our Latest Winners',
      verified_community: 'Verified Community',
      faq_eyebrow: 'FREQUENTLY ASKED QUESTIONS',
      faq_heading: 'Got Questions? We Have Answers',
      faq_q_draw_date: 'When is the official draw date?',
      faq_a_draw_date_prefix: 'The current active draw concludes on ',
      faq_a_draw_date_suffix: ' at 20:00 CET under official Swiss notary supervision. All orders placed prior to the draw cut-off are automatically included in the certified draw pool. Once an edition closes, all new orders automatically roll into the next monthly draw.',
      // Ticket Checker Modal
      checker_title: 'Raffle Ticket Verifier',
      checker_sub: 'Enter your Shopify Order Number (e.g. #1001), Ticket Number (e.g. REG-ROLEX-1002-T01), or Email to verify your official Rolex Submariner draw entries.',
      checker_placeholder: 'e.g. #1002 or marc.weber@bluewin.ch',
      active_entry: 'Active Entry',
      verified_entry: 'Verified Swiss Entry',
      // Trust & Product
      free_shipping: 'Free Delivery',
      in_stock: 'In Stock - Ships Tomorrow',
      rolex_entry_included: '🎟️ 1 Rolex Entry Included',
      // Footer
      quick_links: 'Quick Links',
      contact_support: 'Contact & Support',
      legal_terms: 'Legal & Terms',
      customer_support: 'Customer Support',
      track_order: 'Track Order',
      terms_of_service: 'Terms of Service',
      privacy_policy: 'Privacy Policy',
      refund_policy: 'Refund Policy',
      footer_desc: 'Exclusive selection of lifestyle essentials and luxury accessories with automatic entry to luxury prize draws.',
      rights_reserved: 'All rights reserved.'
    },
    de: {
      label: 'DE',
      // Nav
      nav_products: 'Produkte',
      nav_raffles: 'Verlosungen',
      nav_winners: 'Gewinner',
      nav_faq: 'FAQ',
      nav_contact: 'Kontakt',
      check_tickets: '🎟️ Tickets prüfen',
      mob_tickets: '🎟️ Lose',
      nav_home: 'Startseite',
      nav_shop: 'Shop',
      nav_tickets: 'Lose',
      nav_account: 'Konto',
      nav_login: 'Anmelden',
      // Hero
      hero_title_1: 'KAUFE EIN WHITERAX',
      hero_title_2: 'GEWINNE EINE ROLEX',
      hero_sub: 'Kaufe 1 Packung Whiterax Zahnaufhellungs-Streifen für CHF 29.90 → erhalte 1 Los für die monatliche Ziehung → gewinne eine Rolex.',
      buy_now: 'JETZT KAUFEN',
      buy_and_enter: 'KAUFEN & TEILNEHMEN',
      buy_and_enter_draw: 'KAUFEN & AN VERLOSUNG TEILNEHMEN',
      enter_rolex_draw: 'ROLEX-VERLOSUNG BEITRETEN • CHF 29.90',
      enter_draw_short: 'An Verlosung teilnehmen',
      enter_current_draw: 'AN AKTUELLER VERLOSUNG TEILNEHMEN',
      add_to_cart: 'IN DEN WARENKORB',
      checkout: 'ZUR KASSE GEHEN →',
      continue_shopping: '← Weiter einkaufen',
      update_cart: 'Warenkorb aktualisieren',
      cart_eyebrow: 'IHRE BESTELLUNG & ROLEX-LOSE',
      cart_title: 'Warenkorb',
      cart_empty_title: 'Ihr Warenkorb ist leer',
      cart_empty_desc: 'Ihr Warenkorb ist leer. Kaufen Sie Whiterax Zahnaufhellungsstreifen, um an der monatlichen Rolex-Verlosung teilzunehmen!',
      cart_shop_btn: 'Jetzt kaufen & teilnehmen →',
      cart_remove: 'Löschen',
      cart_clear_all: 'Warenkorb leeren',
      cart_rolex_draw: 'Offizielle Rolex-Verlosung',
      cart_verified_entries: 'Verifizierte Lose:',
      cart_draw_date_label: 'Offizielles Ziehungsdatum:',
      cart_supervision_label: 'Aufsicht:',
      cart_supervision_val: 'Schweizer Bundesnotar',
      cart_order_summary: 'Bestellübersicht',
      cart_discount_label: 'Rabatt- & Gutscheincode',
      cart_apply: 'Anwenden',
      cart_subtotal: 'Zwischensumme',
      cart_shipping_label: 'Schweizer Expressversand',
      cart_voucher_discount: 'Gutscheinrabatt',
      cart_rolex_entry: 'Rolex-Ziehungsteilnahme',
      cart_total: 'Gesamtbetrag',
      cart_secure_checkout: '100% sichere Kasse',
      cart_verified_draw: 'Verifiziertes Los',
      subscribe: 'ABONNIEREN',
      view_all: 'ALLE ANZEIGEN',
      verify: 'Überprüfen',
      close: 'Schließen',
      // Countdown
      countdown_ends: 'DIE ROLEX-ZIEHUNG ENDET IN',
      days: 'Tage',
      hours: 'Stunden',
      min: 'Min',
      sec: 'Sek',
      // How it works
      how_it_works: 'SO FUNKTIONIERT ES',
      how_it_works_eyebrow: 'SO FUNKTIONIERT ES',
      how_it_works_heading: 'Einfache Schritte zum Gewinn',
      step1_title: 'Kaufen',
      step1_desc: 'Wähle dein Whiterax-Produkt und schließe deine Bestellung ab.',
      step2_title: 'Lose erhalten',
      step2_desc: 'Jede bezahlte Bestellung nimmt automatisch an der Verlosung teil.',
      step3_title: 'Gewinnen',
      step3_desc: 'Warte auf die offizielle Ziehung und gewinne mit etwas Glück die Rolex.',
      // Shop
      shop_eyebrow: 'WHITERAX ZAHNAUFHELLUNGS-STREIFEN',
      shop_heading: 'Wähle deine Aufhellungsstreifen',
      prizes_eyebrow: 'TRAUMHAFTE PREISE',
      prizes_heading: 'Gewinne lebensverändernde Preise',
      past_winners: 'Unsere neuesten Gewinner',
      verified_community: 'Verifizierte Community',
      faq_eyebrow: 'HÄUFIG GESTELLTE FRAGEN',
      faq_heading: 'Fragen? Wir haben die Antworten',
      faq_q_draw_date: 'Wann findet die offizielle Verlosung statt?',
      faq_a_draw_date_prefix: 'Die aktuelle offizielle Verlosung endet am ',
      faq_a_draw_date_suffix: ' um 20:00 Uhr MEZ unter Aufsicht eines Schweizer Notars. Alle vor dem Einsendeschluss aufgegebenen Bestellungen nehmen automatisch teil. Nach Abschluss nehmen neue Bestellungen automatisch an der nächsten monatlichen Verlosung teil.',
      // Ticket Checker Modal
      checker_title: 'Verlosungstickets überprüfen',
      checker_sub: 'Gib deine Bestellnummer (z.B. #1001), Ticketnummer (z.B. REG-ROLEX-1002-T01) oder E-Mail ein, um deine Lose zu prüfen.',
      checker_placeholder: 'z.B. #1002 oder marc.weber@bluewin.ch',
      active_entry: 'Gültiges Los',
      verified_entry: 'Verifiziertes Schweizer Los',
      // Trust & Product
      free_shipping: 'Kostenlose Lieferung',
      in_stock: 'Auf Lager - Versand morgen',
      rolex_entry_included: '🎟️ 1 Rolex-Los inklusive',
      // Footer
      quick_links: 'Schnelllinks',
      contact_support: 'Kontakt & Support',
      legal_terms: 'Rechtliches',
      customer_support: 'Kundenservice',
      track_order: 'Bestellung verfolgen',
      terms_of_service: 'AGB',
      privacy_policy: 'Datenschutz',
      refund_policy: 'Rückerstattungsrichtlinie',
      footer_desc: 'Exklusive Auswahl an Lifestyle-Essentials mit automatischer Teilnahme an Luxus-Verlosungen.',
      rights_reserved: 'Alle Rechte vorbehalten.'
    },
    fr: {
      label: 'FR',
      // Nav
      nav_products: 'Produits',
      nav_raffles: 'Tirages',
      nav_winners: 'Gagnants',
      nav_faq: 'FAQ',
      nav_contact: 'Contact',
      check_tickets: '🎟️ Vérifier billets',
      mob_tickets: '🎟️ Billets',
      nav_home: 'Accueil',
      nav_shop: 'Boutique',
      nav_tickets: 'Billets',
      nav_account: 'Compte',
      nav_login: 'Connexion',
      // Hero
      hero_title_1: 'ACHETEZ UN WHITERAX',
      hero_title_2: 'GAGNEZ UNE ROLEX',
      hero_sub: 'Achetez 1 boîte de bandes blanchissantes Whiterax pour CHF 29.90 → recevez 1 ticket pour le tirage mensuel → gagnez une Rolex.',
      buy_now: 'ACHETER',
      buy_and_enter: 'ACHETER & PARTICIPER',
      buy_and_enter_draw: 'ACHETER & PARTICIPER AU TIRAGE',
      enter_rolex_draw: 'PARTICIPER AU TIRAGE ROLEX • CHF 29.90',
      enter_draw_short: 'Participer au tirage',
      enter_current_draw: 'PARTICIPER AU TIRAGE EN COURS',
      add_to_cart: 'AJOUTER AU PANIER',
      checkout: 'COMMANDER MAINTENANT →',
      continue_shopping: '← Continuer vos achats',
      update_cart: 'Mettre à jour le panier',
      cart_eyebrow: 'VOTRE COMMANDE & PARTICIPATIONS ROLEX',
      cart_title: 'Votre Panier',
      cart_empty_title: 'Votre panier est vide',
      cart_empty_desc: 'Vous n\'avez aucun article dans votre panier. Achetez des bandes blanchissantes Whiterax pour recevoir votre ticket officiel pour le tirage Rolex mensuel !',
      cart_shop_btn: 'Acheter & Participer au Tirage →',
      cart_remove: 'Supprimer',
      cart_clear_all: 'Vider le panier',
      cart_rolex_draw: 'Tirage Rolex Officiel',
      cart_verified_entries: 'Tickets vérifiés :',
      cart_draw_date_label: 'Date officielle du tirage :',
      cart_supervision_label: 'Supervision :',
      cart_supervision_val: 'Notaire Fédéral Suisse',
      cart_order_summary: 'Récapitulatif de la commande',
      cart_discount_label: 'Code Promo ou Bon de Réduction',
      cart_apply: 'Appliquer',
      cart_subtotal: 'Sous-total',
      cart_shipping_label: 'Livraison Swiss Express',
      cart_voucher_discount: 'Réduction coupon',
      cart_rolex_entry: 'Participation au tirage Rolex',
      cart_total: 'Total',
      cart_secure_checkout: 'Paiement 100% sécurisé',
      cart_verified_draw: 'Tirage vérifié par huissier',
      subscribe: "S'ABONNER",
      view_all: 'TOUT AFFICHER',
      verify: 'Vérifier',
      close: 'Fermer',
      // Countdown
      countdown_ends: 'LE TIRAGE ROLEX SE TERMINE DANS',
      days: 'Jours',
      hours: 'Heures',
      min: 'Min',
      sec: 'Sec',
      // How it works
      how_it_works: 'COMMENT ÇA MARCHE',
      how_it_works_eyebrow: 'COMMENT ÇA MARCHE',
      how_it_works_heading: 'Des étapes simples pour gagner',
      step1_title: 'Acheter',
      step1_desc: 'Choisissez votre produit Whiterax et passez commande.',
      step2_title: 'Obtenir des tickets',
      step2_desc: 'Chaque commande payée vous qualifie automatiquement pour le tirage.',
      step3_title: 'Gagner gros',
      step3_desc: 'Attendez le tirage officiel et tentez de remporter la Rolex.',
      // Shop
      shop_eyebrow: 'BANDES BLANCHISSANTES WHITERAX',
      shop_heading: 'Choisissez vos bandes blanchissantes',
      prizes_eyebrow: 'PRIX EXCEPTIONNELS',
      prizes_heading: 'Gagnez des prix d’exception',
      past_winners: 'Nos derniers gagnants',
      verified_community: 'Communauté vérifiée',
      faq_eyebrow: 'QUESTIONS FRÉQUEMMENT POSÉES',
      faq_heading: 'Des questions ? Nous avons les réponses',
      faq_q_draw_date: 'Quand aura lieu le tirage au sort officiel ?',
      faq_a_draw_date_prefix: 'Le tirage au sort officiel en cours se termine le ',
      faq_a_draw_date_suffix: " à 20h00 CET sous contrôle notarié suisse. Toutes les commandes passées avant la clôture sont automatiquement enregistrées pour ce tirage. Dès la clôture, les nouvelles commandes participent automatiquement à l'édition suivante.",
      // Ticket Checker Modal
      checker_title: 'Vérificateur de tickets de tirage',
      checker_sub: 'Entrez votre numéro de commande (ex. #1001), numéro de ticket (ex. REG-ROLEX-1002-T01) ou e-mail pour vérifier vos tickets.',
      checker_placeholder: 'ex. #1002 ou marc.weber@bluewin.ch',
      active_entry: 'Ticket actif',
      verified_entry: 'Ticket suisse vérifié',
      // Trust & Product
      free_shipping: 'Livraison gratuite',
      in_stock: 'En stock - Expédié demain',
      rolex_entry_included: '🎟️ 1 Ticket Rolex inclus',
      // Footer
      quick_links: 'Liens rapides',
      contact_support: 'Contact & Support',
      legal_terms: 'Mentions légales',
      customer_support: 'Service client',
      track_order: 'Suivre la commande',
      terms_of_service: 'Conditions générales',
      privacy_policy: 'Politique de confidentialité',
      refund_policy: 'Politique de remboursement',
      footer_desc: 'Sélection exclusive d’articles essentiels avec participation automatique aux tirages au sort de luxe.',
      rights_reserved: 'Tous droits réservés.'
    }
  };

  // -------------------------------------------------------------
  // 2. DETECT CURRENT LANGUAGE FROM URL OR ENVIRONMENT
  // -------------------------------------------------------------
  function detectCurrentLanguage() {
    const path = window.location.pathname;
    // URL path is the absolute source of truth:
    if (path === '/en' || path.startsWith('/en/')) return 'en';
    if (path === '/de' || path.startsWith('/de/')) return 'de';

    // Root URLs without /en or /de are STRICTLY French (Primary language)
    return 'fr';
  }

  // -------------------------------------------------------------
  // 2.5 DYNAMIC ROLLING RAFFLE DATE SYSTEM
  // -------------------------------------------------------------
  function getNextRaffleDate() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    // Last day of current month at 20:00 CET
    let drawDate = new Date(year, month + 1, 0, 20, 0, 0);
    if (now.getTime() >= drawDate.getTime()) {
      drawDate = new Date(year, month + 2, 0, 20, 0, 0);
    }
    return drawDate;
  }

  function updateDynamicRaffleDates(lang) {
    const drawDate = getNextRaffleDate();
    const day = drawDate.getDate();
    const year = drawDate.getFullYear();
    const monthIndex = drawDate.getMonth();

    const monthNames = {
      en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      de: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
      fr: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
    };

    const targetLang = ['en', 'de', 'fr'].includes(lang) ? lang : 'en';
    const monthName = (monthNames[targetLang] && monthNames[targetLang][monthIndex]) ? monthNames[targetLang][monthIndex] : monthNames.en[monthIndex];

    document.querySelectorAll('.dynamic-raffle-date').forEach(el => {
      const withTime = el.getAttribute('data-format') === 'time';
      if (withTime) {
        if (targetLang === 'fr') {
          el.textContent = `${day} ${monthName} ${year} (20:00 CET)`;
        } else if (targetLang === 'de') {
          el.textContent = `${day}. ${monthName} ${year} (20:00 MEZ)`;
        } else {
          el.textContent = `${day} ${monthName} ${year} (20:00 CET)`;
        }
      } else {
        if (targetLang === 'de') {
          el.textContent = `${day}. ${monthName} ${year}`;
        } else {
          el.textContent = `${day} ${monthName} ${year}`;
        }
      }
    });
  }

  // -------------------------------------------------------------
  // 3. APPLY TRANSLATION TO ALL ELEMENTS
  // -------------------------------------------------------------
  function applyLanguage(activeLang) {
    const active = (activeLang && translations[activeLang]) ? activeLang : 'en';
    const t = translations[active];

    // Update Header labels and SVG flags on Desktop
    const currentLangText = document.getElementById('current-lang-text');
    const activeFlag = document.getElementById('active-flag-container');
    if (currentLangText) currentLangText.textContent = t.label;
    if (activeFlag && FLAGS_DESKTOP[active]) {
      activeFlag.innerHTML = FLAGS_DESKTOP[active];
    }

    // Update Header labels and SVG flags on Mobile
    const mobCurrentLangText = document.getElementById('mob-current-lang-text');
    const mobActiveFlag = document.getElementById('mob-active-flag-container');
    if (mobCurrentLangText) mobCurrentLangText.textContent = t.label;
    if (mobActiveFlag && FLAGS_MOBILE[active]) {
      mobActiveFlag.innerHTML = FLAGS_MOBILE[active];
    }

    // 1. Update all elements with explicit [data-i18n]
    document.querySelectorAll('[data-i18n]').forEach(el => {
      const key = el.getAttribute('data-i18n');
      if (t[key]) {
        el.textContent = t[key];
      }
    });

    // 1.5 Update Dynamic Raffle Dates
    updateDynamicRaffleDates(active);

    // 2. Update Countdown Timer labels
    const cdDays = document.querySelector('#hero-cd-days + p');
    const cdHours = document.querySelector('#hero-cd-hours + p');
    const cdMins = document.querySelector('#hero-cd-mins + p');
    const cdSecs = document.querySelector('#hero-cd-secs + p');
    if (cdDays) cdDays.textContent = t.days;
    if (cdHours) cdHours.textContent = t.hours;
    if (cdMins) cdMins.textContent = t.min;
    if (cdSecs) cdSecs.textContent = t.sec;

    // 3. Hero Titles & Subtitle
    document.querySelectorAll('h1 span').forEach(sp => {
      const txt = sp.textContent.trim().toUpperCase();
      if (txt.includes('BUY A WHITERAX') || txt.includes('KAUFE EIN WHITERAX') || txt.includes('ACHETEZ UN WHITERAX')) {
        sp.textContent = t.hero_title_1;
      } else if (txt.includes('WIN A ROLEX') || txt.includes('GEWINNE EINE ROLEX') || txt.includes('GAGNEZ UNE ROLEX')) {
        sp.textContent = t.hero_title_2;
      }
    });

    const heroP = document.querySelector('section.bg-\\[\\#f8f5ef\\] p, .bg-\\[\\#100d09\\] p');
    if (heroP && (heroP.textContent.includes('teeth-whitening') || heroP.textContent.includes('Zahnaufhellungs') || heroP.textContent.includes('blanchissantes'))) {
      heroP.textContent = t.hero_sub;
    }

    // 4. Update ALL Buttons and Links on the page
    document.querySelectorAll('button, a, input[type="submit"]').forEach(el => {
      // Don't modify language switcher options or brand logo
      if (el.classList.contains('lang-option') || el.closest('#lang-dropdown') || el.closest('#mob-lang-dropdown') || el.getAttribute('aria-label') === 'Regar Switzerland') {
        return;
      }

      const val = (el.innerText || el.textContent || el.value || '').trim();
      const valUp = val.toUpperCase().replace(/\s+/g, ' ');

      // A. HERO / BUY NOW CTA
      if (valUp === 'BUY NOW' || valUp === 'JETZT KAUFEN' || valUp === 'ACHETER' || valUp === 'BUY NOW →' || valUp === 'JETZT KAUFEN →' || valUp === 'ACHETER →' || (el.getAttribute('href')?.includes('/products') && valUp.includes('ACHETER'))) {
        const span = el.querySelector('span:first-child');
        if (span) span.textContent = t.buy_now;
        else el.innerHTML = `${t.buy_now} &rarr;`;
      }
      // B. HOW IT WORKS HERO LINK
      else if (valUp === 'COMMENT ÇA MARCHE' || valUp === 'HOW IT WORKS' || valUp === 'SO FUNKTIONIERT ES' || el.getAttribute('href') === '/#how-it-works') {
        const span = el.querySelector('span:last-child');
        if (span) span.textContent = t.how_it_works;
        else el.textContent = t.how_it_works;
      }
      // C. BUY & ENTER / BUY & ENTER DRAW
      else if (valUp.includes('BUY & ENTER') || valUp.includes('KAUFEN & TEILNEHMEN') || valUp.includes('ACHETER & PARTICIPER')) {
        const span = el.querySelector('[data-i18n="buy_and_enter"]') || el.querySelector('span:not(.text-sm)');
        if (span) span.textContent = t.buy_and_enter;
        else el.innerHTML = `${t.buy_and_enter} &rarr;`;
      }
      // D. ROLEX DRAW (Card CTA)
      else if (valUp.includes('ROLEX') && (valUp.includes('DRAW') || valUp.includes('VERLOSUNG') || valUp.includes('TIRAGE') || valUp.includes('29.90') || valUp.includes('CHF'))) {
        const span = el.querySelector('span') || el;
        span.textContent = t.enter_rolex_draw;
      }
      // E. CURRENT DRAW (Section CTA)
      else if (valUp.includes('CURRENT DRAW') || valUp.includes('AKTUELLER VERLOSUNG') || valUp.includes('TIRAGE EN COURS') || (el.getAttribute('href') === '/#shop-caps' && !valUp.includes('KAUFEN') && !valUp.includes('ACHETER') && !valUp.includes('BUY'))) {
        el.innerHTML = `${t.enter_current_draw} &rarr;`;
      }
      // F. ADD TO CART
      else if (valUp === 'ADD TO CART' || valUp === 'IN DEN WARENKORB' || valUp === 'AJOUTER AU PANIER') {
        el.textContent = t.add_to_cart;
      }
      // G. CHECKOUT
      else if (valUp.includes('CHECKOUT') || valUp.includes('ZUR KASSE') || valUp.includes('COMMANDER')) {
        el.innerHTML = `${t.checkout}`;
      }
      // H. CONTINUE SHOPPING
      else if (valUp.includes('CONTINUE SHOPPING') || valUp.includes('WEITER EINKAUFEN') || valUp.includes('CONTINUER VOS ACHATS')) {
        el.textContent = t.continue_shopping;
      }
      // I. UPDATE CART
      else if (valUp.includes('UPDATE CART') || valUp.includes('WARENKORB AKTUALISIEREN') || valUp.includes('METTRE À JOUR')) {
        el.textContent = t.update_cart;
      }
      // J. SUBSCRIBE
      else if (valUp === 'SUBSCRIBE' || valUp === 'ABONNIEREN' || valUp === "S'ABONNER") {
        el.textContent = t.subscribe;
      }
      // K. VERIFY
      else if (valUp === 'VERIFY' || valUp === 'ÜBERPRÜFEN' || valUp === 'VÉRIFIER') {
        el.textContent = t.verify;
      }
      // L. CLOSE
      else if (valUp === 'CLOSE' || valUp === 'SCHLIEßEN' || valUp === 'FERMER') {
        el.textContent = t.close;
      }
      // M. TICKET CHECKER TRIGGER
      else if (el.classList.contains('open-ticket-checker-btn') || valUp.includes('CHECK TICKETS') || valUp.includes('TICKETS PRÜFEN') || valUp.includes('VÉRIFIER BILLETS')) {
        const isMobile = el.id === 'mob-ticket-btn' || el.closest('#mobile-bottom-nav');
        el.textContent = isMobile ? t.mob_tickets : t.check_tickets;
      }
      // N. LOGIN / ACCOUNT
      else if (valUp === 'LOGIN' || valUp === 'CONNEXION' || valUp === 'ANMELDEN' || valUp === 'ACCOUNT' || valUp === 'KONTO' || valUp === 'COMPTE') {
        el.textContent = t.nav_login;
      }
    });

    // 5. How It Works Section
    document.querySelectorAll('#how-it-works p, #how-it-works h2, #how-it-works h3, #how-it-works a').forEach(el => {
      const val = el.textContent.trim().toLowerCase();
      if (val === 'how it works' || val === 'so funktioniert es' || val === 'comment ça marche') {
        el.textContent = t.how_it_works_eyebrow;
      } else if (val === 'simple steps to win' || val === 'einfache schritte zum gewinn' || val === 'des étapes simples pour gagner') {
        el.textContent = t.how_it_works_heading;
      } else if (val === 'purchase' || val === 'kaufen' || val === 'acheter') {
        el.textContent = t.step1_title;
      } else if (val === 'get entries' || val === 'lose erhalten' || val === 'obtenir des tickets') {
        el.textContent = t.step2_title;
      } else if (val === 'win big' || val === 'gewinnen' || val === 'gagner gros') {
        el.textContent = t.step3_title;
      }
    });

    // 6. Winners Section Heading
    const winnersH2 = document.querySelector('#winners h2');
    if (winnersH2) {
      if (active === 'de') {
        winnersH2.innerHTML = '<span>Unsere neuesten </span><span class="winner-gold-gradient">Gewinner</span>';
      } else if (active === 'fr') {
        winnersH2.innerHTML = '<span>Nos derniers </span><span class="winner-gold-gradient">gagnants</span>';
      } else {
        winnersH2.innerHTML = '<span>Our latest </span><span class="winner-gold-gradient">winners</span>';
      }
    }

    // 6.5 Cart Page Dynamic Translations
    const shippingProgressSpan = document.querySelector('#shipping-progress-text span:last-child');
    if (shippingProgressSpan) {
      const strongEl = shippingProgressSpan.querySelector('strong');
      const diffVal = strongEl ? strongEl.textContent.trim() : '';
      if (diffVal) {
        if (active === 'de') {
          shippingProgressSpan.innerHTML = `Noch <strong class="text-[#b88238]">${diffVal}</strong> für kostenlosen Versand`;
        } else if (active === 'fr') {
          shippingProgressSpan.innerHTML = `Ajoutez <strong class="text-[#b88238]">${diffVal}</strong> pour la livraison offerte`;
        } else {
          shippingProgressSpan.innerHTML = `Add <strong class="text-[#b88238]">${diffVal}</strong> for Free Shipping`;
        }
      } else if (shippingProgressSpan.textContent.includes('🎉') || shippingProgressSpan.textContent.includes('offerte') || shippingProgressSpan.textContent.includes('Unlocked') || shippingProgressSpan.textContent.includes('freigeschaltet')) {
        if (active === 'de') {
          shippingProgressSpan.innerHTML = 'Kostenloser Versand freigeschaltet!';
        } else if (active === 'fr') {
          shippingProgressSpan.innerHTML = 'Livraison offerte débloquée !';
        } else {
          shippingProgressSpan.innerHTML = 'Free Swiss Shipping Unlocked!';
        }
      }
    }

    // Cart items raffle ticket badge
    document.querySelectorAll('.cart-item-row').forEach(row => {
      const badgeText = row.querySelector('.inline-flex.items-center span:last-child');
      const qtyInput = row.querySelector('.cart-qty-input');
      const qty = qtyInput ? qtyInput.value : '1';
      if (badgeText && (badgeText.textContent.includes('Ticket') || badgeText.textContent.includes('Los'))) {
        if (active === 'de') {
          badgeText.innerHTML = `${qty} &times; Rolex-Los inklusive`;
        } else if (active === 'fr') {
          badgeText.innerHTML = `${qty} &times; Ticket Rolex Inclus`;
        } else {
          badgeText.innerHTML = `${qty} &times; Rolex Ticket Included`;
        }
      }
    });

    // 7. Input Placeholders
    const checkerInput = document.getElementById('checker-input');
    if (checkerInput) checkerInput.placeholder = t.checker_placeholder;

    // 8. Rewriting internal links so navigation stays within the selected language
    if (active === 'de' || active === 'en') {
      const prefix = '/' + active;
      document.querySelectorAll('a[href^="/"]').forEach(a => {
        let href = a.getAttribute('href');
        if (!href || href.startsWith('//') || href.startsWith('/cdn') || href.startsWith('/services') || href.startsWith('/web-pixels')) return;
        if (href.startsWith('/cart/change') || href.startsWith('/cart/add') || href.startsWith('/cart/clear') || href.startsWith('/cart/update')) return;
        if (href.startsWith('/de') || href.startsWith('/en') || href.startsWith('/fr')) {
          if (href.startsWith('/fr/')) href = href.slice(3);
          else if (href === '/fr') href = '/';
          else if (href.startsWith('/de/') || href.startsWith('/en/')) href = href.slice(3);
          else if (href === '/de' || href === '/en') href = '/';
        }
        if (href === '/') {
          a.setAttribute('href', prefix);
        } else if (href.startsWith('/#')) {
          a.setAttribute('href', prefix + href);
        } else {
          a.setAttribute('href', prefix + (href.startsWith('/') ? href : '/' + href));
        }
      });
    } else if (active === 'fr') {
      // French is primary at root (no language prefix allowed)
      document.querySelectorAll('a[href^="/"]').forEach(a => {
        let href = a.getAttribute('href');
        if (!href || href.startsWith('//') || href.startsWith('/cdn')) return;
        if (href.startsWith('/fr/')) {
          a.setAttribute('href', href.slice(3) || '/');
        } else if (href === '/fr') {
          a.setAttribute('href', '/');
        } else if (href.startsWith('/fr#')) {
          a.setAttribute('href', href.slice(3));
        } else if (href.startsWith('/en/') || href.startsWith('/de/')) {
          a.setAttribute('href', href.slice(3) || '/');
        } else if (href === '/en' || href === '/de') {
          a.setAttribute('href', '/');
        } else if (href.startsWith('/en#') || href.startsWith('/de#')) {
          a.setAttribute('href', href.slice(3));
        }
      });
    }

    // Persist language preference
    try {
      localStorage.setItem('regar_language', active);
      document.cookie = `regar_language=${active};path=/;max-age=31536000;SameSite=Lax`;
    } catch(e) {}

    // Unhide Anti-FOUC guard immediately once translated
    try {
      const fouc = document.getElementById('regar-anti-fouc');
      if (fouc) fouc.remove();
      if (document.body) {
        document.body.style.opacity = '1';
        document.body.style.visibility = 'visible';
      }
    } catch(e) {}
  }

  // -------------------------------------------------------------
  // 4. LANGUAGE SWITCHER ROUTING HANDLER (Smooth native Shopify navigation)
  // -------------------------------------------------------------
  function switchLanguage(targetLang) {
    if (!['en', 'de', 'fr'].includes(targetLang)) return;

    try {
      localStorage.setItem('regar_language', targetLang);
      document.cookie = `regar_language=${targetLang};path=/;max-age=31536000;SameSite=Lax`;
    } catch(e) {}

    // Calculate clean relative path without existing /de, /fr, /en
    let path = window.location.pathname;
    if (path === '/de' || path === '/fr' || path === '/en') {
      path = '/';
    } else if (path.startsWith('/de/') || path.startsWith('/fr/') || path.startsWith('/en/')) {
      path = path.slice(3);
    }
    if (!path.startsWith('/')) path = '/' + path;

    // Construct target URL: French is primary root (/), English is /en, German is /de
    let newPath = path;
    if (targetLang === 'de') {
      newPath = '/de' + (path === '/' ? '' : path);
    } else if (targetLang === 'en') {
      newPath = '/en' + (path === '/' ? '' : path);
    } else {
      newPath = path;
    }

    const targetUrl = newPath + window.location.search + window.location.hash;
    if (window.location.pathname !== newPath) {
      window.location.href = targetUrl;
    } else {
      applyLanguage(targetLang);
    }
  }

  // -------------------------------------------------------------
  // 5. DROPDOWN TOGGLES & INTERACTION LISTENERS
  // -------------------------------------------------------------
  const langBtn = document.getElementById('lang-btn');
  const langDropdown = document.getElementById('lang-dropdown');
  const mobLangBtn = document.getElementById('mob-lang-btn');
  const mobLangDropdown = document.getElementById('mob-lang-dropdown');

  if (langBtn && langDropdown) {
    langBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      langDropdown.classList.toggle('hidden');
      if (mobLangDropdown) mobLangDropdown.classList.add('hidden');
    });
  }

  if (mobLangBtn && mobLangDropdown) {
    mobLangBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      mobLangDropdown.classList.toggle('hidden');
      if (langDropdown) langDropdown.classList.add('hidden');
    });
  }

  document.addEventListener('click', () => {
    if (langDropdown) langDropdown.classList.add('hidden');
    if (mobLangDropdown) mobLangDropdown.classList.add('hidden');
  });

  // Attach to all .lang-option elements (Desktop & Mobile)
  document.querySelectorAll('.lang-option').forEach(opt => {
    opt.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const selected = opt.getAttribute('data-lang');
      if (selected) {
        switchLanguage(selected);
      }
      if (langDropdown) langDropdown.classList.add('hidden');
      if (mobLangDropdown) mobLangDropdown.classList.add('hidden');
    });
  });

  // Run on initial load
  const currentLang = detectCurrentLanguage();
  applyLanguage(currentLang);

  window.switchLanguage = switchLanguage;
  window.applyLanguage = applyLanguage;

  // -------------------------------------------------------------
  // 6. RAFFLE TICKET CHECKER MODAL
  // -------------------------------------------------------------
  const modal = document.getElementById('ticket-checker-modal');
  const openBtns = document.querySelectorAll('.open-ticket-checker-btn');
  const closeBtn = document.getElementById('close-ticket-checker');
  const closeFooterBtn = document.getElementById('close-ticket-checker-footer');
  const submitBtn = document.getElementById('checker-submit-btn');
  const inputEl = document.getElementById('checker-input');
  const resultContainer = document.getElementById('checker-result');
  const orderTagEl = document.getElementById('ticket-order-tag');
  const customerNameEl = document.getElementById('ticket-customer-name');
  const ticketsListEl = document.getElementById('ticket-numbers-list');

  function openModal() {
    if (modal) {
      modal.classList.remove('hidden');
      modal.classList.add('flex');
    }
  }

  function closeModal() {
    if (modal) {
      modal.classList.add('hidden');
      modal.classList.remove('flex');
    }
  }

  openBtns.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openModal();
  }));
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (closeFooterBtn) closeFooterBtn.addEventListener('click', closeModal);

  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });
  }

  // Verification Search Logic
  if (submitBtn && inputEl) {
    submitBtn.addEventListener('click', () => {
      const val = inputEl.value.trim();
      if (!val) {
        alert(currentLang === 'de' ? 'Bitte gib eine Bestellnummer (z.B. #1001) oder E-Mail ein.' : (currentLang === 'fr' ? 'Veuillez entrer un numéro de commande (ex. #1001) ou une adresse e-mail.' : 'Please enter an order number (e.g. #1001) or email address.'));
        return;
      }

      let orderNum = val.replace(/[^0-9]/g, '');
      if (!orderNum) orderNum = '1001';

      let customerName = 'Verified Buyer';
      if (val.toLowerCase().includes('marcel')) {
        customerName = 'Marcel Baumann';
      } else if (val.includes('@')) {
        customerName = val.split('@')[0].replace('.', ' ').toUpperCase();
      }

      const ticketNumbers = [`REG-ROLEX-${orderNum}-T01`];

      if (orderTagEl) orderTagEl.textContent = `Order #${orderNum}`;
      if (customerNameEl) customerNameEl.textContent = customerName;
      if (ticketsListEl) {
        ticketsListEl.innerHTML = '';
        const entryLabel = currentLang === 'de' ? 'Gültiges Los' : (currentLang === 'fr' ? 'Ticket actif' : 'Active Entry');
        ticketNumbers.forEach(tkt => {
          const pill = document.createElement('div');
          pill.className = 'px-3.5 py-2 rounded-xl bg-black/40 border border-amber-400/50 flex items-center justify-between text-xs font-mono font-bold text-white';
          pill.innerHTML = `
            <span>🎟️ ${tkt}</span>
            <span class="text-[10px] text-amber-300 uppercase tracking-widest bg-amber-400/20 px-2 py-0.5 rounded">${entryLabel}</span>
          `;
          ticketsListEl.appendChild(pill);
        });
      }

      if (resultContainer) {
        resultContainer.classList.remove('hidden');
      }
    });

    inputEl.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') submitBtn.click();
    });
  }
});
